import { render, staticRenderFns } from "./detail-base.vue?vue&type=template&id=2c772ed2&scoped=true"
import script from "./detail-base.vue?vue&type=script&lang=js"
export * from "./detail-base.vue?vue&type=script&lang=js"
import style0 from "./detail-base.vue?vue&type=style&index=0&id=2c772ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c772ed2",
  null
  
)

export default component.exports